// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"93d56ab9","541":"c48d8817"}[chunkId] + ".chunk.js";
};